import { render } from "./transbankForm.vue?vue&type=template&id=ca4c0cba&ts=true"
import script from "./transbankForm.vue?vue&type=script&lang=ts"
export * from "./transbankForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__